import { useCallback, useEffect, useState } from 'react';

export interface UseResendCooldownReturn {
  /** Seconds until another may be asked for; 0 when it may. */
  remaining: number;
  /** Start the pause, as a link is sent. */
  start: () => void;
}

/**
 * Seconds-remaining countdown for a "resend" action: the pause after an
 * emailed link is sent, before another can be asked for. The reset page
 * mirrors the backend's password-reset throttle with it; the verify-email
 * page and the gate pause the same way.
 */
export function useResendCooldown(seconds: number): UseResendCooldownReturn {
  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    if (remaining <= 0) return;
    const id = setTimeout(() => setRemaining((s) => s - 1), 1000);
    return () => clearTimeout(id);
  }, [remaining]);

  const start = useCallback(() => setRemaining(seconds), [seconds]);

  return { remaining, start };
}
